import { HugeiconsIcon, IconSvgElement } from "@hugeicons/react";
import {
  ArrowRight01Icon,
  File02Icon,
  MoreVerticalIcon
} from "@hugeicons-pro/core-stroke-rounded";
import { Button, ButtonSize, ButtonVariant } from "shared/components";
import { TemplateLinksSubmenuVariant } from "./types";

interface TemplateLinksMenuTriggerProps {
  variant: TemplateLinksSubmenuVariant;
  disabled?: boolean;
}

export const TemplateLinksMenuTrigger = ({
  variant,
  disabled
}: TemplateLinksMenuTriggerProps) => {
  if (variant === "COMPACT")
    return (
      <div className="flex items-center justify-between w-full gap-2">
        <span className="text-base font-medium text-content-1000">
          Copy application link
        </span>
        <HugeiconsIcon
          icon={MoreVerticalIcon as IconSvgElement}
          size={20}
          strokeWidth={3}
          className="text-content-1000"
        />
      </div>
    );

  if (variant === "BUTTON")
    return (
      <Button
        variant={ButtonVariant.BASE}
        size={ButtonSize.SM}
        className="md:ml-6 w-full sm:w-auto"
        disabled={disabled}
        HugeIcon={MoreVerticalIcon}
        iconStrokeWidth={3}
        iconPosition="right"
      >
        Copy application link
      </Button>
    );

  return (
    <div className="-mx-4 -my-2 w-[272px]">
      <div className="flex items-center justify-between w-full gap-2 px-4 py-2">
        <div className="flex items-center gap-3 flex-1 py-1">
          <HugeiconsIcon
            icon={File02Icon as IconSvgElement}
            size={20}
            stroke="1px"
            className="text-content-200"
          />
          <h2 className="text-base text-content-1000 font-medium">
            Copy application link
          </h2>
        </div>
        <HugeiconsIcon
          icon={ArrowRight01Icon as IconSvgElement}
          size={20}
          strokeWidth={2}
          className="text-content-200"
        />
      </div>
    </div>
  );
};
